import React from 'react';
import { CheckCircle, Calendar, Folder, Trophy, Tv } from 'lucide-react';

export const DISNEY_FOLDER_ICONS: Record<string, React.ReactNode> = {
  'available-now': <CheckCircle size={12} />,
  ctv: <Tv size={12} />,
  espn: <Trophy size={12} />,
  'seasonality-300x600': <Calendar size={12} />
};

export const getDisneyFolderIcon = (sk: string): React.ReactNode => {
  return DISNEY_FOLDER_ICONS[sk] || <Folder size={12} />;
};
